module.exports = __webpack_public_path__ + "img/bg_rhombus2.8c97009d.png";